import React from 'react'
import PropTypes from 'prop-types';
import scrollToElement from 'scroll-to-element';
import '../css/components/Navbar.css';


const NavItems = props => {
    const click = props.clickHandler;
    const currentSection = props.currentSection;
    const navItems = props.items.map(item => {
        return (
            <li className="navbar-item" key={item.name}>
                <a
                    href={"#" + item.name}
                    onClick={(e) => click(e, "#" + item.name)}
                    title={"Navigate to " + item.name}
                    className={"navbar-item navbar-item-dimensions" + (item.name === currentSection ? " active" : "")}>
                    {item.icon}
                </a>
            </li>
        );
    });

    return (
        <nav className="navbar">
            {navItems}
        </nav>
    );
}

NavItems.propTypes = {
    items: PropTypes.array,
    clickHandler: PropTypes.func,
    currentSection: PropTypes.string
};


export default class Navbar extends React.Component {
    static propTypes = {
        items: PropTypes.array,
        currentSection: PropTypes.string
    }

    constructor(props) {
        super(props);

        this.state = {
            isExpanded: false
        }
    }

    navbarMenuClick = () => {
        var newState = (this.state.isExpanded ? false : true);
        this.setState({ isExpanded: newState });
        document.getElementById('navbar-list').classList.toggle('fade-in-down');
    }

    navbarLinkClink = (e, targetHash) => {
        e.preventDefault();
        scrollToElement(targetHash, {
            ease: 'inOutQuad',
            duration: 400
        })
    }


    render() {
        const { items, currentSection } = this.props;
        return (
            <div className="top">
                <div className={"overlay" + (this.state.isExpanded ? " expanded" : "")}>
                    <ul className="navbar-list" id="navbar-list">
                        <NavItems items={items} clickHandler={this.navbarLinkClink} currentSection={currentSection} />
                    </ul>
                </div>
                <div className={"burger-button" + (this.state.isExpanded ? " expanded" : "")} onClick={this.navbarMenuClick}>
                    <span className="burger-line"></span>
                    <span className="burger-line"></span>
                    <span className="burger-line"></span>
                </div>
            </div>
        )
    }
}